import React from 'react'
import Layout from '../../Layout/Layout'

import p2s1 from '../../images/p2s1.PNG'

import p2s2 from '../../images/p2s2.PNG'


const pathway_2_scale = () => {
  return (
    <Layout>
        <div className='uk-container'>
            <div><h2 className='light uk-text-bold uk-margin-xlarge-top'>The Pathway 2 Scale (P2S) </h2></div>


            <div className='uk-grid'>
               <div className='uk-width-1-2@s'>
                      <p className='light'>
                       The Pathway 2 Scale (P2S) ESO Enhancement Program was a strategic 
                       capacity-building initiative funded by the Mastercard Foundation
                        and implemented in partnership with WUSC and Seedstars. Its core 
                        mission was to significantly strengthen the effectiveness and 
                        organizational capacity of various Entrepreneurial Support 
                        Organizations (ESOs) across Nigeria. The program maintained 
                        a dedicated focus on a gender and inclusion lens, ensuring 
                        that support systems were specifically tailored to address 
                        the unique challenges faced by young, rural women entrepreneurs.
                         Moolu Venture Lab was selected with 20 other ESOs across the country.
</p>

                <p className='light'>Key outcomes of the P2S program demonstrate its success in creating
                     a more robust and equitable ecosystem. The initiative resulted in enhanced support
                      structures that are now better equipped to cater to the needs of young, rural
                       women entrepreneurs. Furthermore, the program successfully conducted a 
                       comprehensive mapping of ecosystem gaps, identifying critical deficiencies
                        in areas like digital literacy, access to funding, and generalized 
                        business development support (BDS).
</p>
               </div>

                <div className='uk-width-1-2@s'>
                  <img src= {p2s1} />
               </div>
            </div>


                
            <div className='uk-grid uk-margin-large-top'>
               <div className='uk-width-1-2@s'>
                   <img src= {p2s2} />
               </div>

                <div className='uk-width-1-2@s'>

                             <p className='light'>
                        Moolu Venture Lab was distinguished by its selection as one of the
                         Top 10 Innovation Support Organizations (ISOs) in Nigeria, chosen 
                         from a pool of 250 innovation hubs to participate in the prestigious
                          GIZ/Digital Transformation Center (DTC) capacity development program.
                           This selection is a significant recognition of the Lab's reputation as
                            a trusted enabler and a leading force within Nigeria’s dynamic innovation
                             ecosystem. It validates Moolu Venture Lab's track record and expertise in
                              successfully supporting and scaling enterprises across the country.
</p>

                <p className='light'>The program's core objective is to enhance the support provided
                     to non-tech Micro, Small, and Medium Enterprises (MSMEs), placing a strong 
                     emphasis on accelerating their digital transformation journey. GIZ/DTC achieves 
                     this by providing the selected ISOs, like Moolu Venture Lab, with essential 
                     resources, advanced training, and financial subsidies. This strategic support 
                     is designed to build the ISOs' capacity to better empower MSMEs in adopting 
                     digital tools, thereby improving their operational efficiency and driving 
                     long-term sustainable growth.
</p>
            
               </div>
            </div>





        </div>
        </Layout>
  )
}

export default pathway_2_scale